import { render } from "./Benefit.vue?vue&type=template&id=08f47758&scoped=true"
import script from "./Benefit.vue?vue&type=script&lang=js"
export * from "./Benefit.vue?vue&type=script&lang=js"

import "./Benefit.vue?vue&type=style&index=0&id=08f47758&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f47758"]])

export default __exports__